import { isEntity } from "@/components/ToolCall/ToolCall";
import { getEntityId } from "@cohesive/ui-components";
import {
  CoreActions,
  JsonFormsCore,
  Middleware,
  UPDATE_DATA,
} from "@jsonforms/core";

/**
 * JSONForms middleware that intercepts data changes and maintains
 * normalized data (IDs only) while keeping full entity objects
 * in the form state for display purposes.
 *
 * @see https://jsonforms.io/docs/middleware/
 */
export const jsonFormsEntityToStringMiddleware: Middleware = (
  state: JsonFormsCore,
  action: CoreActions,
  defaultReducer: (state: JsonFormsCore, action: CoreActions) => JsonFormsCore,
): JsonFormsCore => {
  if (action.type === UPDATE_DATA) {
    const newData = "updater" in action && action.updater();

    const schema = state.schema?.properties?.[action.path];
    if (schema?.type === "array" && Array.isArray(newData)) {
      const newState = { ...state, data: { ...state.data } };

      newState.data[action.path] = newData.map((item: any) => {
        if (isEntity(item)) {
          return getEntityId(item);
        }
        return item;
      });

      return newState;
    }

    if (isEntity(newData)) {
      const newState = { ...state, data: { ...state.data } };
      const id = getEntityId(newData);
      newState.data[action.path] = id;

      return newState;
    }
  }

  return defaultReducer(state, action);
};
